// Polskie tłumaczenia dla aplikacji AHP
export const pl = {
  // ========== LOGIN ==========
  login: {
    title: "Login",
    password: "Hasło",
    loginPlaceholder: "Login...",
    passwordPlaceholder: "Hasło...",
    button: "Zaloguj",
    selectLanguage: "Język"
  },

  // ========== TOASTS / POWIADOMIENIA ==========
  toasts: {
    loginSuccess: "Zalogowano poprawnie",
    loginError: "Login lub hasło są niepoprawne"
  },

  // ========== MENU ==========
  menu: {
    title: "AHP Metoda porównań parami",
    logout: "Wyloguj"
  },

  // ========== FORMS / FORMULARZE ==========
  forms: {
    // Domyślna treść stron (HTML) — używana gdy badanie ma puste pole treści
    startPage: `<p>Za chwilę przystąpisz do badania. Poprosimy o ustalenie znaczenie poszczególnych korzyści dostarczanych przez drzewa i krzewy. Nim przejdziesz dalej, upewnij się, że zapoznałeś/-aś się dobrze z przesłanymi <a href="https://docs.google.com/document/d/1he9XOa-yzWXOpTl3ep7PAr1c2dLCD1kzdHQtviV16XY/edit?usp=sharing" target="_blank" rel="noopener noreferrer">ogólnymi informacjami o badaniu</a> oraz <a href="https://youtu.be/MUqhubzGTJM" target="_blank" rel="noopener noreferrer">instrukcją</a>.</p><p>Badanie składa się z 4 stron z porównaniami. Kolejne uruchamiają się po naciśnięciu przycisku "przejdź dalej". W każdej chwili można się też cofnąć do poprzedniej strony (przycisk "cofnij"). W połowie sugerujemy zrobić krótką przerwę. Prosimy nie zapomnieć nacisnąć przycisku "wyślij" po zakończeniu wypełniania. W razie problemów, prosimy kontaktować się z Patrycją Przewoźną pod numerem telefonu <strong>608172288</strong>.</p>`,
    middlePage: `<p>Nie jest dobrze podejmować zbyt wielu decyzji na raz. Ponieważ jesteś dokładnie w połowie badania sugerujemy, byś zrobił/-a sobie choć krótką przerwę, nim wypełnisz drugą część kwestionariusza.</p>`,
    endPage: `<p>Czy chcesz zakończyć badanie i przesłać wyniki? Jeśli tak, naciśnij "wyślij", jeśli chcesz coś poprawić, naciśnij "cofnij".</p>`,

    // Komunikaty walidacji
    validation: {
      maxInconsistency: "Wartość powodująca największą niespójność!",
      answersInconsistent: "Odpowiedzi nie są spójne!",
      answersConsistent: "Odpowiedzi są spójne"
    },
    mark: "Kategoria"
  },

  // ========== BUTTONS / PRZYCISKI ==========
  buttons: {
    back: "Cofnij",
    next: "Przejdź dalej",
    send: "Wyślij",
    check: "SPRAWDŹ",
    logout: "Wyloguj"
  },

  // ========== THANKS / PODZIĘKOWANIA ==========
  thanks: {
    message: "Dziękujemy za Twój poświęcony czas",
    backToLogin: "Wróć do panelu logowania"
  },

  // ========== CHECK COMPONENT ==========
  check: {
    selectPerson: "Wybierz osobę",
    vectorsAndCI: "Wektory i CI",
    saatyMatrix: "Macierz Saati`ego",
    transposedSaatyMatrix: "Transponowana Macierz Saati`ego",
    triangularMatrix: "Macierz trójkątna"
  }
};

export default pl;
